export default __webpack_public_path__ + "/assets/Global/Img/posture1.jpg";